<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li :class="{ active: tabIndex === 0 }" @click="changeTab(0)">
          待支付
        </li>
        <!-- <li :class="tabIndex == 1 ? 'active' : ''" @click="clickTab(1)">
          未付首期
        </li> -->
        <li :class="{ active: tabIndex === 2 }" @click="changeTab(2)">
          已支付
        </li>
        <li :class="{ active: tabIndex === 3 }" @click="changeTab(3)">
          教材订单<Badge :count="Number(materialCount)"></Badge>
        </li>
      </ul>
    </div>

    <div class="member-main-body">
      <div class="no-data" v-show="filterOrderList.length == 0 && tabIndex < 3">
        <img src="../../assets/images/v3/no-data.png" />
        <p>您还没有订单，快去购买课程</p>
        <Button
          type="primary"
          shape="circle"
          style="width: 100px; margin-top: 10px"
          :to="{ name: 'ProductList' }"
          >选购课程</Button
        >
      </div>
      <div class="no-data" v-show="materialList.length == 0 && tabIndex === 3">
        <img src="../../assets/images/v3/no-data.png" />
        <p>您还没有教材订单</p>
      </div>
      <ul class="order-list" v-if="tabIndex < 3">
        <li v-for="(item, index) in filterOrderList" :key="index">
          <div class="order-no">订单号：{{ item.orderNo }}</div>
          <div class="order-item">
            <div class="order-img">
              <img
                style="width: 100%"
                :src="concatImageUrl(item.image, 280, 160)"
              />
            </div>
            <div class="order-info">
              <div class="name">{{ item.name }}</div>
              <div class="time">{{ item.orderTime }}</div>
              <div class="money">
                <span>￥</span>
                <span>{{ item.money }}</span>
              </div>
            </div>
            <div class="order-action">
              <div v-if="item.payResult == 1">
                <Button
                  type="default"
                  size="large"
                  disabled
                  shape="circle"
                  long
                >
                  已 支 付
                </Button>
              </div>
              <div v-else>
                <Dropdown trigger="click" style="width: 100px;">
                  <Button
                    type="warning"
                    size="large"
                    shape="circle"
                    style="height:32px;border-radius: 32px;font-size:14px;"
                    long
                  >
                    立即支付
                  </Button>
                  <Dropdown-menu slot="list">
                    <div
                      class="pay-list"
                      v-for="(pay, index) in paymentList"
                      :key="index"
                    >
                      <a @click="toPayment(pay, item)" href="javascript:;">
                        {{ pay.name }}
                      </a>
                    </div>
                  </Dropdown-menu>
                </Dropdown>
              </div>
              <div class="order-del">
                <Poptip
                  confirm
                  title="您确定要删除当前订单么?"
                  placement="top-end"
                  @on-ok="deleteOrder(item)"
                >
                  <Button
                    type="default"
                    size="large"
                    shape="circle"
                    style="height:32px;border-radius: 32px;font-size:14px;"
                    long
                  >
                    删除订单
                  </Button>
                </Poptip>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <ul class="order-list" v-if="tabIndex === 3">
        <li v-for="(item, index) in materialList" :key="index">
          <div class="order-no">{{ item.orderNo }}</div>
          <div class="order-item">
            <div class="order-img">
              <img
                style="width: 100%"
                :src="concatImageUrl(item.filename, 280, 160)"
              />
            </div>
            <div class="order-extend">
              <div class="name">{{ item.productName }}</div>
              <div class="time">{{ item.createDate }}</div>
              <template v-if="item.ifWriteReceive === 0">
                <div class="send">未填写收货信息</div>
                <div class="send"></div>
                <div class="send"></div>
                <div class="send"></div>
              </template>
              <template v-if="item.ifWriteReceive == 1 && item.status === 0">
                <div class="send">教材处理中...</div>
                <div class="send"></div>
                <div class="send"></div>
                <div class="send"></div>
              </template>
              <!-- <template v-else>
                <div class="send">物流状态：已发货</div>
                <div class="send">发货时间：{{ item.sendTime }}</div>
                <div class="send">物流公司：{{ item.logisticsName }}</div>
                <div class="send">物流单号：{{ item.logisticsOrder }}</div>
              </template> -->
            </div>
            <div class="order-action extend">
              <p style="margin-bottom:16px;">
                <Button
                  type="primary"
                  size="large"
                  shape="circle"
                  long
                  @click="viewMaterial(item)"
                  >查看教材</Button
                >
              </p>
              <Button
                type="primary"
                size="large"
                shape="circle"
                long
                @click="handleAddress(item)"
              >
                <template v-if="item.ifWriteReceive === 0">
                  填写收货信息
                </template>
                <template v-else>
                  编辑收货信息
                </template>
              </Button>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div v-html="alipayForm" ref="alipayWrapper"></div>
    <Modal
      v-model="addressVisible"
      title="收货信息"
      :mask-closable="false"
      :loading="addressLoading"
      :footer-hide="!isEditAddress"
      width="624"
      class-name="vertical-center-modal"
      @on-ok="submitAddress"
    >
      <div style="width:96%;padding-top:16px;">
        <Form
          ref="formValidate"
          :model="formValidate"
          :rules="ruleValidate"
          :label-width="80"
        >
          <FormItem label="收货人" prop="name">
            <Input
              v-model="formValidate.name"
              placeholder="请输入收货人信息"
              :maxlength="100"
            ></Input>
          </FormItem>
          <FormItem label="收货电话" prop="phone">
            <Input
              v-model="formValidate.phone"
              placeholder="请输入收货人电话"
              :maxlength="50"
            ></Input>
          </FormItem>
          <FormItem label="收货地址" required prop="address">
            <Cascader
              :data="formAddressTree"
              v-model="formAddressVal"
              @on-change="validateField"
            ></Cascader>
            <Input
              v-model="formValidate.address"
              type="textarea"
              placeholder="请输入详细地址..."
              :autosize="{ minRows: 2, maxRows: 2 }"
              :maxlength="500"
              style="margin-top: 16px"
              @on-blur="validateField"
            />
            <p style="color:orange" v-if="!isEditAddress">
              订单正在处理不可编辑收货信息，如信息有误，可联系教务老师
            </p>
            <!-- <p style="color:orange" v-if="receiveType == 0 && sendStatus == 1">
              订单正在处理不可编辑收货信息，如信息有误，可联系教务老师
            </p>
            <p style="color:orange" v-if="receiveType == 1 && sendStatus == 1">
              订单已发货不可编辑收货信息，如信息有误，可联系快递公司进行更改
            </p> -->
          </FormItem>
        </Form>
      </div>
    </Modal>

    <!-- 查看教材 -->
    <Modal
      v-model="materialVisible"
      title="查看教材"
      width="800"
      class-name="vertical-center-modal"
      footer-hide
    >
      <Table
        :columns="materialColumns"
        size="small"
        border
        :data="materialDataList"
      ></Table>
    </Modal>
  </div>
</template>

<script>
import { siteMixin } from "../../utils/mixin";
import { user, order } from "../../request";
import {
  saveOrderInfo,
  removeOrderInfo,
  savePayQrcode,
} from "../../utils/localStorage";

import { getAreaTreeData } from "../../utils/areaList";

export default {
  mixins: [siteMixin],
  data() {
    const validateAddress = (rule, value, callback) => {
      setTimeout(() => {
        if (!this.formAddressVal.length || !value) {
          return callback(new Error("请选择并输入收货地址"));
        }
        callback();
      }, 0);
    };
    return {
      tabIndex: 0,
      orderList: [],
      paymentList: [],
      alipayForm: "",
      materialList: [], //教材订单列表
      materialCount: 0,
      addressVisible: false,
      addressLoading: true,
      formAddressTree: getAreaTreeData(3), //地址树状列表，省市区三级
      formAddressVal: [],
      formValidate: {
        id: 0,
        name: "",
        phone: "",
        address: "",
      },
      ruleValidate: {
        name: [
          { required: true, message: "请输入收货人信息", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入收货电话", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
        ],
        address: [
          {
            validator: validateAddress,
            trigger: "blur",
          },
        ],
      },
      isEditAddress: true,
      receiveType: null,
      materialVisible: false,
      materialColumns: [{ title: "教材", key: "nameVersion" }],
      tempColumns: [
        { title: "物流公司", key: "company", width: 100 },
        { title: "物流单号", key: "order", width: 150 },
        { title: "发货时间", key: "sendTime", width: 150 },
      ],
      materialDataList: [],
      sendStatus: 0,
    };
  },
  computed: {
    filterOrderList() {
      if (this.tabIndex == 0) {
        return this.orderList.filter((item) => item.payResult == 0);
      } else if (this.tabIndex == 1) {
        return this.orderList.filter((item) => item.payResult == 2);
      } else {
        return this.orderList.filter((item) => item.payResult == 1);
      }
    },
  },
  mounted() {
    this.setMetaData("我的订单");
    this.getMyOrder();
    this.getPaymentList();
    this.getMaterialList();
    this.getOrderCount();
  },
  methods: {
    getMyOrder() {
      user.getMyOrder(this.loginUser.userId).then((res) => {
        //console.log("orderlist", res);
        if (res.status == 1) {
          this.orderList = res.data;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    deleteOrder(item) {
      user.deleteOrder(item.orderID).then((res) => {
        if (res.status === 1) {
          this.getMyOrder();
          this.$Message.success("订单删除成功");
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    changeTab(index) {
      if (this.tabIndex == index) return false;
      this.tabIndex = index;
    },
    getPaymentList() {
      order.getPaymentType(this.siteConfig.agencyId).then((res) => {
        //console.log("paymentList", res);
        if (res.status == 1) {
          var list = res.data;
          this.paymentList = list;
          if (this.paymentList.length > 0) {
            this.currentPayment = this.paymentList[0].type;
            //只有个人二维码时的逻辑处理
            if (this.currentPayment == 4) {
              let qrcode = {
                wxqr: "",
                aliqr: "",
                payTel: "",
              };
              this.paymentList[0].url.forEach((item) => {
                if (item.name == "微信二维码") {
                  qrcode.wxqr = item.wxqr;
                  qrcode.payTel = item.payTel;
                }
                if (item.name == "支付宝二维码") {
                  qrcode.aliqr = item.aliqr;
                  qrcode.payTel = item.payTel;
                }
              });
              savePayQrcode(qrcode);
            }
          }
        }
      });
    },
    toPayment(pay, orderInfo) {
      saveOrderInfo(orderInfo.orderNo, orderInfo.money, orderInfo.name);
      const paymentType = pay.type;
      switch (paymentType) {
        case "1":
          this.$router.push({ name: "PaymentWx" });
          break;
        case "2":
          order
            .paymentWithAlipay(this.loginUser.userId, orderInfo.orderNo)
            .then((res) => {
              if (res.status == 1) {
                this.alipayForm = res.data;
                removeOrderInfo();
                this.$nextTick(() => {
                  this.$refs.alipayWrapper.children[0].setAttribute(
                    "target",
                    "_blank"
                  );
                  this.$refs.alipayWrapper.children[0].submit();
                });
              } else {
                this.$Message.error("请求支付接口错误");
              }
            });
          break;
        case "3":
          this.$router.push({ name: "PaymentUnion" });
          break;
        case "4":
          this.$router.push({ name: "PaymentQrcode" });
          break;
        default:
          this.$router.push({ name: "Home" });
          break;
      }

      console.log(pay, order);

      //this.$router.push({ name: "PaymentQrcode" });
    },
    getMaterialList() {
      order.getMaterialOrders(this.loginUser.userId).then((res) => {
        // console.log("aaaaa", res);
        if (res.status == 1) {
          this.materialList = res.data;
        }
      });
    },
    getMaterialSub(id) {
      return new Promise((resolve) => {
        order.getMaterialSubOrder(id).then((res) => {
          // console.log("res", res);
          if (res.status == 1) {
            this.sendStatus = res.data.sendStatus || 0;
            this.materialDataList =
              res.data.list?.map((item) => {
                return {
                  ...item,
                  nameVersion: item.edition
                    ? `${item.name}-${item.edition}`
                    : item.name,
                };
              }) || [];
            resolve();
          }
        });
      });
    },
    getOrderCount() {
      order.getMaterialOrderCount(this.loginUser.userId).then((res) => {
        if (res.status === 1) {
          this.materialCount = res.data;
        }
      });
    },
    validateField() {
      this.$refs["formValidate"].validateField("address");
    },
    handleAddress(item) {
      this.formValidate.id = item.id;
      this.isEditAddress = item.editStatus !== 1;
      this.receiveType = item.receivetype != null ? item.receivetype : -1;
      order.getMaterialOrderDetail(item.id).then((res) => {
        if (res.status === 1) {
          const {
            receivename,
            receivemobile,
            receiveprovince,
            receivecity,
            receivearea,
            receiveaddress,
          } = res.data;
          this.formValidate.name = receivename;
          this.formValidate.phone = receivemobile;
          this.formValidate.address = receiveaddress;
          if (receiveprovince) {
            this.formAddressVal = [receiveprovince, receivecity, receivearea];
          } else {
            this.formAddressVal = [];
          }
          this.addressVisible = true;
        }
      });
      // this.getMaterialSub(item.id);
    },
    submitAddress() {
      this.$refs["formValidate"].validate((valid) => {
        if (valid) {
          const { id, name, phone, address } = this.formValidate;
          const req = {
            id,
            receivename: name,
            receivemobile: phone,
            receiveprovince: this.formAddressVal[0] || "",
            receivecity: this.formAddressVal[1] || "",
            receivearea: this.formAddressVal[2] || "",
            receiveaddress: address,
          };
          order.editMaterialAddress(req).then((res) => {
            if (res.status === 1) {
              this.$Message.success("收货信息提交成功");
              this.addressVisible = false;
              this.getMaterialList();
            }
          });
        }
      });
      this.addressLoading = false;
      this.$nextTick(() => {
        this.addressLoading = true;
      });
    },
    viewMaterial(item) {
      this.receiveType = item.receivetype != null ? item.receivetype : -1;
      if (this.receiveType == 1) {
        this.materialColumns = [{ title: "教材", key: "nameVersion" }],
        this.materialColumns = [...this.materialColumns, ...this.tempColumns];
      } else {
        this.materialColumns = this.materialColumns.slice(0, 1);
      }
      this.getMaterialSub(item.id).then(() => {
        this.materialVisible = true;
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
@import "../../assets/css/member-main.less";
.order-list {
  padding: 30px;
  li {
    border-bottom: 1px solid #ddd;
    padding-bottom: 30px;
    margin-bottom: 30px;
  }
  .order-no {
    font-weight: bold;
    font-size: 16px;
    padding-bottom: 30px;
  }
  .order-item {
    display: flex;
    align-items: center;
    .order-img {
      width: 280px;
      height: 160px;
      border-radius: 6px;
      overflow: hidden;
      img {
        width: 280px;
      }
    }
    .order-info {
      flex: 1;
      margin-left: 20px;
      .name {
        font-size: 16px;
        height: 60px;
        line-height: 30px;
      }
      .time {
        font-size: 15px;
        color: #666;
      }
      .money {
        margin-top: 30px;
        color: #fa4418;
        span {
          &:last-child {
            font-size: 24px;
          }
        }
      }
    }
    .order-extend {
      flex: 1;
      margin-left: 20px;
      line-height: 26px;
      .time {
        font-size: 15px;
        color: #666;
      }
      .send {
        min-height: 26px;
      }
    }
    .order-action {
      width: 100px;
      &.extend {
        width: 130px;
      }
      .pay-list {
        a {
          display: block;
          margin: 2px auto;
          padding: 5px 15px;
          &:hover {
            background: #f5f5f5;
          }
        }
      }
      .order-del {
        margin-top: 20px;
        text-align: left;
        width: 100%;
        /deep/.ivu-poptip-rel {
          width: 100px;
        }
        /deep/.ivu-poptip-popper {
          width: 220px;
        }
      }
    }
  }
}
</style>
